import api from 'api'
import { IWebinar } from 'interfaces/webinars'

const getWebinars = async () => {
  const response = await api.get('/administration/sidebar_shortcuts/meetings')
  return response.data.data.map(
    (item: { attributes: IWebinar }) => item.attributes
  )
}

export default getWebinars
